// import React, { useEffect, useState } from "react";

// const JobList = ({ onApply }) => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch("https://bemss.in/api/emp/mrf/?mrf_status=Open&page=1") // ← client GET API
//       .then(res => res.json())
//       .then(data => {
//         setJobs(data.results || []);
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error("Job fetch failed", err);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) return <p>Loading jobs...</p>;
//   if (!jobs.length) return <p>No job openings available</p>;

//   return (
//     <>
//       {jobs.map(job => (
//         <div key={job.id} className="job-card job-card--alt mb-3">
//           <div className="job-card-accent"></div>

//           <div className="job-card-content">
//             <div className="job-card-header">
//               <h2 className="job-title">
//                 {job.designation_display?.name}
//               </h2>
//             </div>

//             <div className="job-meta">
//               <span className="job-location">
//                 {job.site_location}
//               </span>
//               <span className="dot"></span>
//               <span className="job-updated">
//                 Updated: {job.submission_date}
//               </span>
//             </div>

//             <div className="job-tags">
//               {job.skill_sets?.split(",").map(skill => (
//                 <span key={skill} className="tag">{skill}</span>
//               ))}

//               <button
//                 className="btn-solid"
//                 onClick={() => onApply(job.id)}
//               >
//                 Apply
//               </button>
//             </div>
//           </div>
//         </div>
//       ))}
//     </>
//   );
// };

// export default JobList;
import React, { useEffect, useState } from "react";

const JobList = ({ onApply }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(
          "https://bemss.in/api/emp/mrf/?mrf_status=Open&page=1"
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setJobs(data.results || []);
      } catch (err) {
        console.error("Job fetch failed:", err);
        setError("Unable to load job openings.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) return <p>Loading jobs...</p>;
  if (error) return <p>{error}</p>;
  if (!jobs.length) return <p>No job openings available</p>;

  return (
    <>
      {jobs.map(job => (
        <div key={job.id} className="job-card job-card--alt mb-3">
          <div className="job-card-accent"></div>

          <div className="job-card-content">
            <div className="job-card-header">
              <h2 className="job-title">
                {job.designation_display?.name || "Untitled Position"}
              </h2>
            </div>

            <div className="job-meta">
              <span className="job-location">
                {job.site_location || "N/A"}
              </span>
              <span className="dot"></span>
              <span className="job-updated">
                Updated: {job.submission_date || "N/A"}
              </span>
            </div>

            <div className="job-tags">
              {job.skill_sets
                ?.split(",")
                .map(skill => (
                  <span key={skill.trim()} className="tag">
                    {skill.trim()}
                  </span>
                ))}

              <button
                className="btn-solid"
                onClick={() => onApply(job.id)}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default JobList;
